import React, { useState, useEffect, Fragment } from "react"
import MetaTags from 'react-meta-tags';
import { useSelector } from "react-redux";

import { Link, useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import moment from 'moment';
import {  getCarList, getDriverList, getCollectZoneList } from "../../crud/search.crud"
import {  getCollectScheduleData, saveCollectSchedule, deleteCollectSchedule  } from "../../crud/collect.crud"
import {  getCompanyList, getTreatmentCompanyList } from "../../crud/contract.crud"

import Util from "pages/Dashboard/Common/Util";

import loading from "../../assets/images/loading.gif";
import SelectBox from "components/RopikCustom/SelectBox";
import Modal from "components/RopikCustom/Modal_v2";
import * as XLSX from 'xlsx';

const dayArr = [
  '일', '월', '화', '수', '목', '금', '토'
]

const dayData = [
    { 'id' : 0, 'name' : '일'},
    { 'id' : 1, 'name' : '월'},
    { 'id' : 2, 'name' : '화'},
    { 'id' : 3, 'name' : '수'},
    { 'id' : 4, 'name' : '목'},
    { 'id' : 5, 'name' : '금'},
    { 'id' : 6, 'name' : '토'},
]

const initSearchCondition = {
  car: '',  
  day : '',
  // collectDate: moment(new Date).format('YYYY-MM-DD'),  
  driver: ''
}

const initInputCondition = {
  id: '',
  companyName: '',
  treatmentCompanyName : '',
  collectZone: '',    
  car: '',  
  day_of_week : '',
  // collectDate: moment(new Date).format('YYYY-MM-DD'),
  driver: '',
}


const CollectSchedule = () => {

  const selector = useSelector(state => state)
  const history = useHistory()

  const [dataList, setDataList] = useState([]);
  const [companyId, setCompanyId] = useState(selector.auth?.user?.member_group?.[0]?.company_group.id)
  const [isLoading, setIsLoading] = useState(false);
  const [searchCondition, setSearchCondition] = useState(initSearchCondition)
  const [selectedCompany, setSelectedCompany] = useState('')
  const [companyData, setCompanyData] = useState([]);
  const [carData, setCarData] = useState([]);
  const [driverData, setDriverData] = useState([]);  
  const [collectZoneData, setCollectZoneData] = useState([]);
  const [treatmentCompanyData, setTreatmentCompanyData] = useState([]);
  const [modalShow, setModalShow] = useState({
    create: false,
    edit: false,
    delete: false
  })  
  const [createItem, setCreateItem] = useState({})
  const [selectedItem, setSelectedItem] = useState(initInputCondition)

  const getCompanyData = async () => {
    try {
      const response = await getCompanyList();
      if (response.status === 200) {
        const content = response.data?.data || [];
        if (content.length > 0) {
          let items = []
          for(let i=0; i< content.length; i++){            
            const rs = content[i]
            const item = {
              id : rs.company || '',
              name : rs.company_name || '',
              contract : rs.contract || '',              
            }
            items.push(item)
          }
          setCompanyData(items)
        } else {
          setCompanyData([])
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getTreatmentCompanyData = async (contract_id) =>{
    try {
      setIsLoading(true)
      const response = await getTreatmentCompanyList(contract_id);
      if (response.status === 200) {
        const content = response.data?.data || [];
        if (content.length > 0) {
          setTreatmentCompanyData([...content])
        } else {
          setTreatmentCompanyData([])
        }
      }
      setIsLoading(false)
    } catch (error) {
      console.error(error);
      setIsLoading(false)
    }
  }


  const getDriverDataList = async () => {
    try {
      const response = await getDriverList();
      if (response.status === 200) {
        const content = response.data?.data || [];
        if (content.length > 0) {
          setDriverData([...content])
        } else {
          setDriverData([])
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getCarDataList = async () => {
    try {
      const response = await getCarList();
      if (response.status === 200) {
        const content = response.data?.data || [];
        if (content.length > 0) {
          setCarData([...content])
        } else {
          setCarData([])      
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getCollectZoneDataList = async () => {
    try {
      const response = await getCollectZoneList();
      if (response.status === 200) {
        const content = response.data?.data || [];
        if (content.length > 0) {
          setCollectZoneData([...content])
        } else {
          setCollectZoneData([])      
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getDataList = async (item) => {
    setIsLoading(true)
    try {

      const params = {
        car : item?.car || '',
        driver : item?.driver || '',
        collect_date: item?.day || '', 
      }

      const response = await getCollectScheduleData(params);
      if (response.status === 200) {
        const content = response.data?.data || [];
        if (content.length > 0) {
          setDataList([...content])
        } else {  
          setDataList([])                        
        }
      }
      setIsLoading(false)
    } catch (error) {
      console.error(error);
      setIsLoading(false)
    }
  }


  const changeCompanyInputCondition = (key, value) => {    
    const val = companyData.filter(itm => itm.id == value)    
    getTreatmentCompanyData(val?.[0]?.contract || '')  
    setSelectedItem(prev => ({...prev, [key]: value}))    
  }


  const changeSearchCondition = (key, value) => {
    setSearchCondition(prev => ({...prev, [key]: value}))
  }

  const modalOpen = (key) => {
    setModalShow(prev => ({...prev, [key] : true}))
  }

  const modalClose = (key) => {
    setModalShow(prev => ({...prev, [key] : false}))
  }

  const deleteCompany = async() => {
    const params = {
      company: selectedCompany
    }
    const rs = await console.log(params)
    console.log(rs)
  }

  const excelDownload = async () => {
    const table = document.getElementById('excel-table');
    if (!table) return;

    const rows = table.querySelectorAll('tr');
    const data = [];

    for (let i = 0; i < rows.length; i++) {
      const cells = rows[i].querySelectorAll('td, th');
      const rowData = [];

      for (let j = 0; j < cells.length; j++) {
        rowData.push(cells[j].innerText);
      }

      data.push(rowData);
    }

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array'
    });

    const blob = new Blob(
      [wbout],
      { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' }
    );

    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${'스케줄 목록'}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  }

  const onSearch = async() => {
    const params = {...searchCondition}
    getDataList(params)    
  }

  const deleteSchedule = async() => {
    try {
      setIsLoading(true)
      const params = {
          id : selectedItem?.id
      }
      const response = await deleteCollectSchedule(params);   
      modalClose('edit')         
      modalClose('deactivate')
      onSearch()
      setIsLoading(false)
    } catch (error) {
      console.error(error);
      setIsLoading(false)
    }
  }

  const saveCollectScheduleData = async () => {
    try {
      setIsLoading(true)
  
      const params = {
          id : selectedItem?.id || '',
          company_id: selectedItem?.companyName,
          treatment_id : selectedItem?.treatmentCompanyName,
          collect_zone: selectedItem?.collectZone,
          car_id: selectedItem?.car,
          day_of_week: selectedItem?.day_of_week,    
          member_id: selectedItem?.driver,          
          memo: selectedItem?.memo
      }
      const response = await saveCollectSchedule(params);      
      modalClose('edit')
      onSearch()
      setIsLoading(false)
    } catch (error) {
      console.error(error);
      setIsLoading(false)
    }
  }
  
  const changeInputCondition = (key, value) => {
    setSelectedItem(prev => ({...prev, [key]: value}))
  }

  const getClosestFutureDateByDayNumber = (targetDayNumber) => {
    // targetDayNumber: 0 (일요일) - 6 (토요일)

    const today = new Date(); // 현재 날짜와 시간
    const currentDay = today.getDay(); // 오늘 요일 (0: 일요일, 1: 월요일, ..., 6: 토요일)

    let daysToAdd;

    if (targetDayNumber >= currentDay) {
      // 찾으려는 요일이 오늘 요일과 같거나 미래인 경우 (이번 주 포함)
      daysToAdd = targetDayNumber - currentDay;
    } else {
      // 찾으려는 요일이 오늘 요일보다 과거인 경우 (다음 주를 찾아야 함)
      daysToAdd = (7 - currentDay) + targetDayNumber;
    }

    // 오늘 날짜에 계산된 일수를 더하여 결과 날짜를 만듦
    const resultDate = new Date(today); // today 객체를 직접 수정하지 않기 위해 복사
    resultDate.setDate(today.getDate() + daysToAdd);

    // YYYY-MM-DD 형식으로 변환
    const year = resultDate.getFullYear();
    const month = String(resultDate.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1, 두 자리로 포맷
    const day = String(resultDate.getDate()).padStart(2, '0'); // 두 자리로 포맷

    return `${year}-${month}-${day}`;
  }

  useEffect(() => {
    getCompanyData()
    getCollectZoneDataList()
    getCarDataList()    
    getDriverDataList()
    getDataList()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>수거 스케줄 관리 / 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs maintitle="Home" title="수거 관리" breadcrumbItem="수거 스케줄 관리" />

          <div className="d-flex w-100 gap-30">
            <div className="email-rightbar mb-3 flex-grow-1">
              <Card>
                <CardBody className="padding-0">
                  <table className="input-table">
                    <tbody>
                      <tr>
                        <td className="col-10 padding-left-8 primary-bg white-text font-size-12">차량선택</td>
                        <td className="col-20">
                            <SelectBox
                              value={searchCondition.car}
                              onChange={changeSearchCondition}
                              options={carData}
                              keyValue={'car'}
                            />
                        </td>
                        <td className="col-10 padding-left-8 primary-bg white-text font-size-12">요일선택</td>
                        <td className="col-20">
                            <SelectBox
                              value={searchCondition.day}
                              onChange={changeSearchCondition}
                              options={dayData}
                              keyValue={'day'}
                            />
                        </td>
                        <td className="col-10 padding-left-8 primary-bg white-text font-size-12">기사선택</td>
                        <td className="col-20">
                            <SelectBox
                              value={searchCondition.driver}
                              onChange={changeSearchCondition}
                              options={driverData}
                              keyValue={'driver'}
                            />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </CardBody>
              </Card>
            </div>
            <div className="d-flex flex-direction-column align-items-end">
              <button style={{width: 143}} type="button" className="custom-btn btn-dark-gradient margin-bottom-8 border-radius-0 white-text border-none margin-right-0 margin-top-6" onClick={() => {
                onSearch()
              }}>
                검색
              </button>
              <button style={{width: 143}} type="button" className="custom-btn border-radius-0 margin-bottom-8 primary-bg white-text button-border margin-right-0" onClick={() => {
                modalOpen('edit')
              }}>
                스케줄 수동 등록
              </button>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center mb-2">
            <p className="mb-0 font-size-16"><span className="font-weight-bold">스케줄 목록</span> [ 건수 : {dataList.length}건 ]</p>
            <div className="waver-pagination-btn-group" >
              <button style={{width: 143}} className="custom-btn success-bg border-radius-0 white-text border-none margin-right-0"
              onClick={() => {
                excelDownload()
              }} >
                엑셀 다운로드
              </button>
            </div>
          </div>
          <Row>
            <Col xs="12">
              <div className="email-rightbar mb-3">

                <Card>
                  <CardBody style={{padding: 0, borderRadius: 4, overflow: 'hidden'}}>
                    <div className="table-responsive">
                      <table id="excel-table" className="table table-hover table-centered table-nowrap mb-0 chart-table">
                        <thead className="chart-thead">
                          <tr>
                            <th scope="col">No</th>
                            <th scope="col">수거요일</th>
                            <th scope="col">상호명</th>
                            <th scope="col">차량번호</th>
                            <th scope="col">운반기사</th>
                            <th scope="col">처리장명</th>
                            <th scope="col">수거구역</th>
                            <th scope="col">소재지</th>
                            <th scope="col">수정</th>
                          </tr>
                        </thead>
                        <tbody className="chart-tbody">
                          {dataList.map((item, index) => {
                            return (
                              <tr key={item.id + '_' + index}>
                                <td className="pointer" >{dataList.length - index}</td>
                                <td className="pointer" >{dayArr[item.day_of_week]}</td>
                                <td className="pointer" >{item.company_name || ''}</td>
                                <td className="pointer" >{item.car_number || ''}</td>
                                <td className="pointer" >{item.driver_name}</td>
                                <td className="pointer" >{item.treatment_name}</td>
                                <td className="pointer" >{item.collect_zone_name}</td>
                                <td className="pointer" >{item.company_address}</td>                                
                                <td>
                                  <div className="btn-group waver-common-btn-group w-90">
                                    <Button type="button" size="sm" className="w-100 waves-effect center-btn btn-common small disactive" onClick={async(e) => {  
                                      e.stopPropagation()      
                                      const val = companyData.filter(itm => itm.id == item.company)    
                                      await getTreatmentCompanyData(val?.[0]?.contract || '')                                                                                            
                                      setSelectedItem({
                                        id: item?.id,
                                        companyName: item.company,
                                        treatmentCompanyName : item?.treatment,
                                        car: item.car,
                                        collectZone: item.collect_zone,
                                        day_of_week: item.day_of_week,
                                        driver: item.member,
                                        memo : item.memo
                                      })
                                      modalOpen('edit')
                                    }}>수정</Button>
                                  </div>
                                </td>
                              </tr>
                            )
                          })}
                          {dataList.length === 0 &&
                            <tr>
                              <td scope="row" colSpan="14">데이터가 없습니다.</td>
                            </tr>
                          }

                        </tbody>
                      </table>
                    </div>
                  </CardBody>

                </Card>

              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal
        title={selectedItem?.id ? '수거 스케줄 수정' : '수거 스케줄 등록'}
        show={modalShow.edit}
        onHide={() => {
          modalClose('edit')
          setSelectedItem(null)
        }}
        size="lg"
        bodyChildren={
          <Fragment>
            <table className="input-table">
              <tbody>
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">차량선택</td>
                  <td className="w-35">
                    <SelectBox
                      value={selectedItem?.car || ''}
                      onChange={changeInputCondition}
                      options={carData}
                      keyValue={'car'}
                    />
                  </td>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">기사선택</td>
                  <td className="w-35">
                    <SelectBox
                      value={selectedItem?.driver || ''}
                      onChange={changeInputCondition}
                      options={driverData}
                      keyValue={'driver'}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">수거요일</td>
                  <td className="w-35">
                    <SelectBox
                      value={selectedItem?.day_of_week}
                      onChange={changeInputCondition}
                      options={dayData}
                      keyValue={'day_of_week'}
                    />
                  </td>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">수거구역</td>
                  <td className="w-35 text-end">                    
                    <SelectBox
                      value={selectedItem?.collectZone}
                      onChange={changeInputCondition}
                      options={collectZoneData}
                      keyValue={'collectZone'}
                    />
                  </td>
                </tr>
                <tr> 
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">상호명</td>
                  <td className="w-35">
                    <SelectBox
                      value={selectedItem?.companyName || ''}
                      onChange={changeCompanyInputCondition}
                      options={companyData}
                      keyValue={'companyName'}
                    />     
                  </td>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">처리장명</td>
                  <td className="w-35">
                    <SelectBox
                      value={selectedItem?.treatmentCompanyName || ''}
                      onChange={changeInputCondition}
                      options={treatmentCompanyData}
                      keyValue={'treatmentCompanyName'}
                    />   
                  </td>
                </tr>
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text">메모</td>
                  <td colSpan="3" className="w-85 pb-0">
                    <textarea className="waver-text-box w-100 font-size-12 border-radius-0" value={selectedItem?.memo}
                    onChange={(e)=>{
                      changeInputCondition('memo', e.target.value);
                    }} />
                  </td>
                </tr>
              </tbody>
            </table>
          </Fragment>
        }
        footerChildren={
        <div className="d-flex justify-content-between w-100">
          <div>
            { selectedItem?.id && 
              <button style={{width: 112, height: 27}} className="`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 error-bg white-text border-none" onClick={() => {
                modalOpen('deactivate')
              }}>수거 스케줄 삭제</button>
            }
          </div>
          <div className="d-flex">
            <button style={{width: 112, height: 27}} className="`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 secondary-bg white-text border-none" onClick={() => {
              saveCollectScheduleData()
            }}>{selectedItem?.id ? '수거 스케줄 수정' : '수거 스케줄 등록'}</button>
            <button style={{width: 59, height: 27}} className="custom-btn border-radius-0 font-size-11 line-height-1 button-border secondary-text white-bg margin-right-0" onClick={() => {
              setSelectedItem(null)
              modalClose('edit')
            }}>취소</button>
          </div>
        </div>
        }
      />

      <Modal
        title={'수거 스케줄 삭제'}
        show={modalShow.deactivate}
        onHide={() => {
          modalClose('deactivate')
        }}
        size="md"
        bodyChildren={
          <Fragment>
            <p>수거 스케줄에서 해당 가맹점의 수거 스케줄이<br/>삭제됩니다.</p>
            <p className="mb-0">정말 삭제 하시겠습니까?</p>
          </Fragment>
        }
        footerChildren={
        <div className="d-flex justify-content-end">
          <button style={{width: 'auto'}} type="button" className="waves-effect custom-btn active btn btn-dark-gradient btn-sm" onClick={() => {
            deleteSchedule()
          }}>
            확인
          </button>
          <button style={{width: 'auto'}} type="button" className="waves-effect custom-btn active btn btn-white-border btn-sm" onClick={() => {
            modalClose('deactivate')
          }}>
            취소
          </button>
        </div>
        }
      >
      </Modal>
      {isLoading && <div style={{
        position: "absolute",
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        bacround: 'rgba(255, 255, 255, 0.6)',
        zIndex: 9999,
        display: "flex",
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <img src={loading} alt="로딩중입니다." width={'3%'}></img>
      </div>}
    </React.Fragment>
  )
}

export default CollectSchedule
